import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { initGA } from './utils/analytics';
import './index.css';
import App from './App';

// Inicializa Google Analytics quando a aplicação carrega
if (process.env.NODE_ENV === 'production') {
  initGA();
}

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap pré-renderiza o HTML no build. Quando o HTML já vem com conteúdo,
// hidratamos em vez de recriar a árvore do zero.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
